<!--
 * @Desc:
 * @Author: may.li
 * @Date: 2023-05-11 14:11:36
 * @LastEditors: lc
 * @LastEditTime: 2023-06-06 15:16:07
-->
<template>
  <div class="app-container">
    <!-- 查询条件 -->
    <div class="search-div common-section-bg">
      <div class="shaixuan-item">
        <el-input
          v-model="queryParam.key"
          size="mini"
          clearable
          placeholder="请输入关键词查找"
        />
      </div>
      <div class="shaixuan-item">
        <el-button
          type="primary"
          size="mini"
          icon="el-icon-search"
          @click="searchClick()"
        >
          查询
        </el-button>
        <el-button
          type="primary"
          size="mini"
          icon="el-icon-plus"
          @click="clickItem(0)"
        >
          新增
        </el-button>
      </div>
    </div>
    <!-- 列表展示 -->
    <div class="common-section-bg common-section-body">
      <el-table
        v-loading="listLoading"
        :data="tableData"
        size="mini"
        style="width: 100%; min-height: 300px"
      >
        <el-table-column
          prop="id"
          label="id"
          width="180"
        />
        <el-table-column
          prop="name"
          label="名称"
          width="200"
        />
        <el-table-column
          prop="admin"
          label="状态"
        >
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              size="mini"
              class="drawer-switch"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="1"
              :inactive-value="0"
              @change="changeStatus(scope.row)"
            />
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          align="center"
          label="操作"
          width="180"
        >
          <template slot-scope="scope">
            <div class="btns-wrap">

              <el-button
                type="danger"
                style="
                                    background: #1067e0;
                                    border-color: #1067e0;
                                "
                size="mini"
                @click="clickItem(1, scope.row)"
              >修改</el-button>
              <el-button
                      type="danger"
                      size="mini"
                      @click="remove(scope.row)"
              >删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <pagination
        v-show="total"
        :total="total"
        :page.sync="queryParam.page"
        :limit.sync="queryParam.size"
        @pagination="getList"
      />
    </div>
    <el-drawer
      custom-class="custom-drawer"
      :visible.sync="showDrawer"
      :close-on-press-escape="false"
      :wrapper-closable="false"
      :show-close="false"
      size="532px"
    >
      <template slot="title">
        <div class="custom-title">
          <div class="title-name">{{ isEdit ? "编辑" : "新增" }}</div>
          <i
            class="el-icon-circle-close close-btn pointer"
            @click="closeDrawerFun"
          />
        </div>
      </template>
      <div class="custom-content">
        <DepartmentAdd
          ref="DepartmentAdd"
          @onUpdateDrawer="onUpdateDrawer($event)"
        />
      </div>
    </el-drawer>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import Cookies from 'js-cookie'
import Department from '@/api/console/Department'
import DepartmentAdd from './DepartmentAdd.vue'
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
export default {
  components: {
    Pagination,
    DepartmentAdd
  },
  data() {
    return {
      queryParam: {
        key: '',
        page: 1,
        size: 10
      },
      total: 0,
      listLoading: false,
      tableData: [],
      isEdit: 0, // 0新增 1编辑
      showDrawer: false
    }
  },
  created() {
  },
  mounted() {
    this.getList()
  },
  methods: {
    /**
 * @name: 更改状态
 * @param {*} val
 * @return {*}
 * @desc:
 */
    changeStatus(val) {
      const params = {
        section_id: val.id,
        status: val.status?1:0
      }
      Department.status(params).then(res => {
        // eslint-disable-next-line eqeqeq
        if (res.code == 200) {
          this.getList()
        } else {
          this.getList()
          this.$message.error(res.message)
        }
      })
    },
    // 更新弹层状态
    onUpdateDrawer(status) {
      console.log('status', status)
      // eslint-disable-next-line eqeqeq
      if (status == 1) {
        // 成功
        this.showDrawer = false
        this.getList()
        // eslint-disable-next-line eqeqeq
      } else if (status == -1) {
        // 失败
        this.showDrawer = false
      }
    },
    /**
     * @name: 关闭弹层
     * @return {*}
     * @desc:
     */
    closeDrawerFun() {
      this.showDrawer = false
      this.$refs.DepartmentAdd.resetForm()
    },
    /**
     * @name: 点击子项 0新增 1编辑
     * @param {*} type
     * @param {*} id
     * @return {*}
     * @desc:
     */
    clickItem(type, row) {
      const that = this
      this.showDrawer = true
      this.isEdit = type
      // 给组件传值
      const obj = {
        type: type,
        id: row ? row.id : ''
      }
      this.$nextTick(function() {
        that.$refs.DepartmentAdd.initFun(obj)
      })
    },
    /* 查询按钮，页码重置，查询数据 */
    searchClick() {
      this.queryParam.page = 1
      this.getList()
    },
    /* 查询tableData数据 */
    getList() {
      const that = this
      this.listLoading = true
      Department.list(that.queryParam).then((res) => {
        that.listLoading = false
        that.tableData = res.result.list
        that.total = res.result.total
      })
    },
    remove(row) {
      const that = this
      that.$confirm('确定删除该内容吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 调用接口
          Department.remove({ section_id: row.id }).then((res) => {
            // eslint-disable-next-line eqeqeq
            if (res.code == 200) {
              that.$message.success(res.message)
              that.getList()
            } else {
              that.$message.error(res.message)
            }
          })
        })
        .catch(() => { })
    }
  }
}
</script>

<style lang="scss" scoped>
.app-container {
  min-height: calc(100vh - 98px);
}
</style>
